import type { AcademyCustomPage } from '~/generated_types';
import type {
  CourseObject,
  ScormObject as ScormObjectBase,
  ResourceObject as ResourceObjectBase,
  CollectionObject as CollectionObjectBase,
  CertificationObject as CertificationObjectBase,
  EventObject as EventObjectBase,
} from '../../types';

export enum ObjectType {
  collection = 'collection',
  certification = 'certification',
  path = 'path',
  guide = 'guide',
  resource = 'resource',
  event = 'event',
  scorm = 'scorm',
}

type PageObjectSource = AcademyCustomPage['LEARNER_DETAIL']['pageSections'][number]['pageObjects'][number];

type CertificationObject = {
  objectType: ObjectType.certification;
  learnerObject: CertificationObjectBase;
};

type PathObject = {
  objectType: ObjectType.path;
  learnerObject: CertificationObjectBase;
};

type CollectionObject = {
  objectType: ObjectType.collection;
  learnerObject: CollectionObjectBase;
};

type EventObject = {
  objectType: ObjectType.event;
  learnerObject: EventObjectBase;
};

type GuideObject = {
  objectType: ObjectType.guide;
  learnerObject: CourseObject;
};
type ResourceObject = {
  objectType: ObjectType.resource;
  learnerObject: ResourceObjectBase;
};

type ScormObject = {
  objectType: ObjectType.scorm;
  learnerObject: ScormObjectBase;
};

export type PageObject = Omit<PageObjectSource, 'objectType' | 'learnerObject'> &
  (CertificationObject | CollectionObject | EventObject | GuideObject | ResourceObject | ScormObject | PathObject);

export type PageObjectOnlyTrainings = Omit<PageObjectSource, 'objectType' | 'learnerObject'> &
  (GuideObject | ResourceObject | ScormObject);
